module.exports = __webpack_public_path__ + "img/stage5.408da36a.png";